/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Avatar/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Avatar({
  children,
  initials,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/IntegrationsApplications/Content/SyncPatients/Content/SyncPatients/Content/PatientCard/Avatar",
  backgroundColor,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  marginTop = 0,
  marginBottom = 0,
  marginRight = 0,
  marginLeft = 0,
  onClick,
  height,
  width,
  size
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let backgroundColorOrdtColorsNeutral400 = backgroundColor ?? dtColorsNeutral400
let borderTopLeftRadiusOrdtSpaceL = borderTopLeftRadius ?? dtSpaceL
let borderTopRightRadiusOrdtSpaceL = borderTopRightRadius ?? dtSpaceL
let borderBottomLeftRadiusOrdtSpaceL = borderBottomLeftRadius ?? dtSpaceL
let borderBottomRightRadiusOrdtSpaceL = borderBottomRightRadius ?? dtSpaceL
let heightOrdtSpaceL = height ?? dtSpaceL
let widthOrdtSpaceL = width ?? dtSpaceL
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<button
  data-testid="Avatar.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-2ktN6P': backgroundColorOrdtColorsNeutral400,'--btlr-2-2ktN6P': typeof borderTopLeftRadiusOrdtSpaceL === 'number' ? `${borderTopLeftRadiusOrdtSpaceL}px` : borderTopLeftRadiusOrdtSpaceL,'--btrr-3-2ktN6P': typeof borderTopRightRadiusOrdtSpaceL === 'number' ? `${borderTopRightRadiusOrdtSpaceL}px` : borderTopRightRadiusOrdtSpaceL,'--bblr-4-2ktN6P': typeof borderBottomLeftRadiusOrdtSpaceL === 'number' ? `${borderBottomLeftRadiusOrdtSpaceL}px` : borderBottomLeftRadiusOrdtSpaceL,'--bbrr-5-2ktN6P': typeof borderBottomRightRadiusOrdtSpaceL === 'number' ? `${borderBottomRightRadiusOrdtSpaceL}px` : borderBottomRightRadiusOrdtSpaceL,'--mt-6-2ktN6P': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-7-2ktN6P': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mr-8-2ktN6P': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-9-2ktN6P': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--h-10-2ktN6P': typeof heightOrdtSpaceL === 'number' ? `${heightOrdtSpaceL}px` : heightOrdtSpaceL,'--w-11-2ktN6P': typeof widthOrdtSpaceL === 'number' ? `${widthOrdtSpaceL}px` : widthOrdtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral700}
 size={size}
 text={initials}
/>
</button>
{children}
</React.Fragment>)
}